import React from 'react';

import { Box, Typography } from '@mui/material';

import { ShowFnOutput } from 'mui-modal-provider';

import {
  OfferCategory,
  Reservation,
  ShippingStatus,
  UserUpdateStatus,
} from '../../../../graphql/API';
import { useUpdateReservationMutation } from '../../../../pages/ReservationDetail/components/useMutation';
import LoadingButton from '../../../Button/LoadingButton';
import { BaseDialogProps } from '../../Base';

export type CancelReservationProps = {
  reservationDetail?: Reservation;
  modalRef: React.MutableRefObject<ShowFnOutput<BaseDialogProps> | undefined>;
  refetchReservationDetails?: () => void;
  getReservationsLimitInPeriodHandle?: () => void;
};

export const CancelReservation: React.FC<CancelReservationProps> = ({
  reservationDetail,
  modalRef,
  refetchReservationDetails,
  getReservationsLimitInPeriodHandle,
}) => {
  const cancelReservationMutation = useUpdateReservationMutation({
    onSuccess: () => {
      modalRef.current?.destroy();
      if (refetchReservationDetails) {
        refetchReservationDetails();
      }
      if (getReservationsLimitInPeriodHandle) getReservationsLimitInPeriodHandle();
    },
  });

  const onCancelHandle = React.useCallback(() => {
    modalRef.current?.destroy();
  }, [modalRef]);

  const onCancelReservationHandle = () => {
    if (reservationDetail?.id) {
      cancelReservationMutation.mutate({
        id: reservationDetail.id,
        status: UserUpdateStatus.cancelled,
        shippingStatus:
          reservationDetail.offer?.category === OfferCategory.product
            ? ShippingStatus.cancelled
            : undefined,
      });
    }
  };

  return (
    <Box>
      <Typography
        paddingTop={reservationDetail?.offer?.shopifyProductID ? '22px' : '34px'}
        paddingBottom={'44px'}
      >
        {reservationDetail?.offer?.category === OfferCategory.product &&
        reservationDetail?.offer?.shopifyProductID
          ? `The reservation will be canceled and the user will be notified. This will also result in the cancellation of the order on Shopify.`
          : 'The reservation will be canceled and the user will be notified.'}
      </Typography>

      <Box display={'flex'} alignItems={'center'} gap={'20px'}>
        <LoadingButton
          fullWidth
          variant={reservationDetail?.offer?.shopifyProductID ? 'text' : 'outlined'}
          size='large'
          sx={{ paddingY: '12px' }}
          onClick={onCancelHandle}
        >
          {reservationDetail?.offer?.category === OfferCategory.product
            ? 'Keep reservation'
            : 'Keep'}
        </LoadingButton>
        <LoadingButton
          fullWidth
          loading={cancelReservationMutation.isPending}
          variant='contained'
          type='submit'
          size='large'
          sx={
            !reservationDetail?.offer?.shopifyProductID
              ? {
                  backgroundColor: '#e05757',
                  paddingY: '12px',
                  ':hover': {
                    backgroundColor: '#e05757',
                  },
                }
              : { paddingY: '14px', paddingX: '24px' }
          }
          onClick={onCancelReservationHandle}
        >
          {reservationDetail?.offer?.shopifyProductID
            ? 'Cancel reservation'
            : reservationDetail?.offer?.category === OfferCategory.product
              ? 'Cancel'
              : 'Delete'}
        </LoadingButton>
      </Box>
    </Box>
  );
};
